module.exports = __webpack_public_path__ + "static/img/EcoStruxure-Asset-Advisor.f66c80e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/EcoStruxure-Asset-Advisor.jpg
// module id = k81r
// module chunks = 0